import { render, staticRenderFns } from "./MessageTemplatesCreate.vue?vue&type=template&id=dd1ea3b8"
import script from "./MessageTemplatesCreate.vue?vue&type=script&lang=js"
export * from "./MessageTemplatesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports